import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { Route, Switch, withRouter, match } from 'react-router-dom';
import { compose } from 'recompose';
import { RouteChildrenProps } from 'react-router';
import { Container } from 'semantic-ui-react';

import { AccountDetails as AccountDetailType } from 'scenes/AccountManagement/AccountManagement.helpers';
import { ClassProp } from 'helpers/types';
import { Theme } from 'config';

import AccountDetails from './scenes/AccountDetails';
import AccountDetailsUpdate from './scenes/AccountDetailsUpdate';

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  classes: Styles;
  match: match;
  accountDetails: AccountDetailType;
};

const styles = (theme: Theme) => ({
  container: {
    justifyContent: 'center !important',
    marginBottom: '2rem !important',
  },
});

const acctDetails = (
  routeProps: RouteChildrenProps,
  classes: ClassProp<typeof styles>,
  accountDetails: AccountDetailType,
) => <AccountDetails accountDetails={accountDetails} />;

const updateAcctDetails = (
  routeProps: RouteChildrenProps,
  classes: ClassProp<typeof styles>,
  accountDetails: AccountDetailType,
) => <AccountDetailsUpdate accountDetails={accountDetails} />;

const AccountInformation: FunctionComponent<Props> = ({
  classes,
  match,
  accountDetails,
}) => {
  const renderAcctDetails = (routeProps: RouteChildrenProps) =>
    acctDetails(routeProps, classes, accountDetails);

  const renderUpdateAccountDetails = (routeProps: RouteChildrenProps) =>
    updateAcctDetails(routeProps, classes, accountDetails);

  return (
    <Container className={classes.container}>
      <Switch>
        <Route
          path={`${match.path}/details/update`}
          component={renderUpdateAccountDetails}
          exact
        />
        <Route path={`${match.path}`} component={renderAcctDetails} exact />
      </Switch>
    </Container>
  );
};

export default compose<Props, any>(
  withStyles(styles),
  withRouter,
)(AccountInformation);
